import {rankingYears} from "../../../constants/ranking";
import {IOfferRankingOptionValue} from "../../../types/IOfferRankingFormOptionValue";

export function getOfferRankingFormPeriodOptions(): IOfferRankingOptionValue[] {
    return rankingYears.map((year) => ({
        value: year.toString(),
        label: year.toString()
    }));
}
import {rankingYears} from "../../../constants/ranking";
import {IOfferRankingOptionValue} from "../../../types/IOfferRankingFormOptionValue";

export function getOfferRankingFormPeriodOptions(): IOfferRankingOptionValue[] {
    return rankingYears.map((year) => ({
        value: year.toString(),
        label: year.toString()
    }));
}
